import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col
} from 'reactstrap';


const ResultBreakPoints = ({high, low, units}) => (
  <Container className='border'>
    <Row>
      <Col className='my-2'>
        <strong>High</strong>
      </Col>
      <Col className='my-2'>{`>= ${high} ${units}`}</Col>
    </Row>
    <Row className='border-top'>
      <Col className='my-2'>
        <strong>Borderline</strong>
      </Col>
      <Col className='my-2'>{`${low} - < ${high} ${units}`}</Col>
    </Row>
    <Row className='border-top'>
      <Col className='my-2'>
        <strong>Low</strong>
      </Col>
      <Col className='my-2'>{`< ${low} ${units}`}</Col>
    </Row>
  </Container>
);

ResultBreakPoints.propTypes = {
  high: PropTypes.number,
  low: PropTypes.number,
  units: PropTypes.string
};

export default ResultBreakPoints;


// WEBPACK FOOTER //
// src/components/reportManagement/ResultBreakPoints/index.jsx